'use client'

import { useCallback, useMemo } from 'react'

import { Brand } from 'modules/products'
import ExpandablePanel from 'shared/ui/ExpandablePanel'
import { RadioItem } from 'shared/ui/RadioGroup'

import { FiltersRadioGroup } from './styles'

interface ProducerFilterMobileProps {
  brands: Brand[]
  value: string | null
  onChange: (path: string, value: string | null) => void
}

const ProducerFilterMobile = ({
  brands,
  onChange,
  value
}: ProducerFilterMobileProps) => {
  const selectedValue = useMemo(() => value ?? 'all', [value])

  const handleSelect = useCallback(
    (filterValue: string) => {
      onChange('brand_id', filterValue === 'all' ? null : filterValue)
    },
    [onChange]
  )

  return (
    <ExpandablePanel title={'Producent'} id='producer-filter-mobile'>
      <FiltersRadioGroup
        name='mobile-brands'
        selectedValue={selectedValue}
        onChange={handleSelect}
      >
        <RadioItem key={'mobile-brands-all'} value='all'>
          Wszyscy
        </RadioItem>
        {brands?.map(brand => (
          <RadioItem key={`mobile-${brand.id}`} value={brand.id}>
            {brand.name} ({brand.productsCount})
          </RadioItem>
        ))}
      </FiltersRadioGroup>
    </ExpandablePanel>
  )
}

export default ProducerFilterMobile
